import { makeRequest } from 'utils/requestLogger';

export default (rtID) => makeRequest('delete', `/api/roundtables/${rtID}`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/deleteRoundtable.js